// extracted by mini-css-extract-plugin
export var childrenContainer = "_3s-0";
export var virtualScrollArea = "_3s-1";